module.exports = __webpack_public_path__ + "files/2a45a79de9cf894f84f3c76311ad55a5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/animals_nature-3.png
// module id = 510
// module chunks = 76